import React, { ButtonHTMLAttributes } from 'react';

import { Icon } from '../Icon';
import { colors } from '../../styles/tokens';
import { Container, IconWrapper } from './styles';

interface buttonProps extends ButtonHTMLAttributes<HTMLButtonElement> {
  name: string;
  value: string;
  arrowRight?: boolean;
}

const ButtonSecurity: React.FC<buttonProps> = ({
  name,
  value,
  arrowRight = true,
  ...rest
}) => {
  return (
    <Container type="submit" {...rest}>
      <span>{value}</span>
      {arrowRight && (
        <IconWrapper>
          <Icon
            name="chevron_right"
            size={20}
            color={colors.onSurfaceVariant}
          />
        </IconWrapper>
      )}
    </Container>
  );
};

export { ButtonSecurity };
